import Component from "./component";

const TIME_INCREMENT = 100;

class Speed extends Component {
  constructor(speed) {
    super();
    this.value = speed;
    this.delay = TIME_INCREMENT / this.value;
  }

  quadruple() {
    this.value *= 4;
    this.delay = TIME_INCREMENT / this.value;
  }

  double() {
    this.value *= 2;
    this.delay = TIME_INCREMENT / this.value;
  }

  halve() {
    this.value /= 2;
    this.delay = TIME_INCREMENT / this.value;
  }

  quarter() {
    this.value /= 4;
    this.delay = TIME_INCREMENT / this.value;
  }

  actionDelay() {
    return this.owner.isPlayer() ? this.delay + this.owner.stats.agilityModifier : this.delay;
  }
}

export default Speed;
